import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Software India | Leading Software Development Company in India',
  description = 'Software India - Top-rated software development company offering cutting-edge solutions in web, mobile, and enterprise applications. Expert developers, innovative technologies, and unparalleled service.',
  keywords = 'Software India, software development, web development, mobile apps, enterprise solutions, IT services, Indian software company, web design, UI/UX design, video editing, branding, SEO',
  image = '/logo512.png',
  url = 'https://www.softwareindia.com',
  type = 'website',
  structuredData = null,
  canonical = null,
}) => {
  const fullImageUrl = image.startsWith('http') ? image : `${url}${image}`;
  const canonicalUrl = canonical || url;
  const siteName = 'Software India';

  // Default structured data for Organization
  const defaultStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Software India',
    url: 'https://www.softwareindia.com',
    logo: `${url}/logo512.png`,
    description: 'Leading software development company in India offering cutting-edge solutions in web, mobile, and enterprise applications.',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'IN',
    },
    sameAs: [
      'https://www.instagram.com/soft.wareindia/',
      'https://www.facebook.com/',
      'https://www.linkedin.com/company/softwareindia/',
      'https://www.twitter.com/',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      url: `${url}/contact`,
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      reviewCount: '230',
    },
  };

  const finalStructuredData = structuredData || defaultStructuredData;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Software India" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:site" content="@softwareindia" />
      <meta name="twitter:creator" content="@softwareindia" />

      {/* Additional Meta Tags */}
      <meta name="geo.region" content="IN" />
      <meta name="geo.placename" content="India" />
      <meta name="theme-color" content="#000000" />
      <meta name="msapplication-TileColor" content="#000000" />

      {/* Structured Data / JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(finalStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
